/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useEffect, useRef, useState } from "react";
import { graphql } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import Subscription from "~components/Subscription";
import ProductGrid from "~components/ProductGrid";
import SEO from "~components/SEO";
import { parseProducts, parseSubscriptions } from "~utils/shopify";

const ProductsPage = ({ data, location }) => {
  const {
    activeCategories,
    setActiveCategories,
    subnavActive,
    subnavLink,
    setSubnavLink
  } = useContext(AppContext);
  const { device, scrollTop, windowWidth } = useContext(DocumentContext);

  const scrollRefs = {
    preorder: useRef(),
    subscription: useRef()
  };

  const [filtersVisible, setFiltersVisible] = useState(true);

  //

  const { allDataYaml } = data;

  let open = true;

  if (allDataYaml?.edges?.[0]?.node) {
    ({ open } = allDataYaml.edges[0].node);
  }

  //

  const { frontmatter } = data.markdownRemark;

  const products = parseProducts(data);
  const subscriptions = parseSubscriptions(data);

  const categories = [`All`];

  if (products?.[0]) {
    products.forEach(product => {
      if (product?.frontmatter?.categories?.[0]) {
        product.frontmatter.categories.forEach(category => {
          if (!categories.includes(category)) {
            categories.push(category);
          }
        });
      }
    });
  }

  //

  const toggleCategory = category => {
    if (category === `All`) {
      setActiveCategories([`All`]);
      return;
    }

    let categoriesClone = JSON.parse(JSON.stringify(activeCategories));

    const allIndex = categoriesClone.indexOf(`All`);

    if (allIndex !== -1) {
      categoriesClone.splice(allIndex, 1);
    }

    const categoryIndex = categoriesClone.indexOf(category);

    if (categoryIndex !== -1) {
      categoriesClone.splice(categoryIndex, 1);
    } else {
      categoriesClone.push(category);
    }

    if (!categoriesClone?.[0]) {
      categoriesClone = [`All`];
    }

    setActiveCategories(categoriesClone);
  };

  //

  useEffect(() => {
    if (!scrollRefs?.subscription?.current) {
      return;
    }

    if (scrollRefs.subscription.current.getBoundingClientRect().top < 180) {
      if (filtersVisible) {
        setFiltersVisible(false);
      }
    } else if (!filtersVisible) {
      setFiltersVisible(true);
    }
  }, [scrollTop]);

  //

  useEffect(() => {
    if (subnavLink) {
      const scrollRef = scrollRefs?.[subnavLink];

      if (typeof window !== `undefined` && scrollRef?.current) {
        let top = 0;

        if (subnavLink !== `preorder`) {
          top = scrollRef.current.offsetTop;

          if (device === `mobile`) {
            top += windowWidth + 120;
          }
        }

        window.scrollTo({
          top,
          behavior: `smooth`
        });
      }

      setSubnavLink(null);
    }
  }, [subnavLink]);

  //

  const squiggleJSX = (
    <div className="grid-end-12 md:grid-end-8 md:grid-start-3 relative gpu">
      {(windowWidth < 1400 && (
        <img
          className="w-full relative block"
          src={`/uploads/squiggle-${
            device && device === `desktop` ? `md` : `sm`
          }.svg`}
          alt="Squiggle Medium"
        />
      )) || (
        <img
          className="w-full relative block"
          src="/uploads/squiggle-lg.svg"
          alt="Squiggle Medium"
        />
      )}
    </div>
  );

  //

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="products-page w-full relative bg-dark-green text-cream">
        <section className="w-full relative block pt-32 md:pt-48 text-center">
          <div className="grid">
            <article className="grid-end-12 sm:grid-end-10 md:grid-end-8 sm:grid-start-2 md:grid-start-3">
              <h1
                className={`animation-appear-down-slow animation-delay-2 ${
                  device === `desktop` ? `f2` : `f3`
                }`}
              >
                Fresh from the oven
              </h1>

              <p className="animation-appear-down-slow animation-delay-3 mt-8 f5">
                We use only the finest ingredients, and we favour organic,
                sustainable and local produce.
              </p>

              <p className="animation-appear-down-slow animation-delay-4 mt-4 f5">
                The result is hearfelt goodness with quality baked in.
              </p>
            </article>
          </div>
        </section>

        <section
          className={`products-page__filters ${
            !subnavActive && filtersVisible ? `active` : ``
          } w-full relative z-10 pt-16 md:pt-20 pb-6 text-center`}
        >
          <div className="animation-appear-down-slow animation-delay-4 grid items-start">
            {squiggleJSX}

            <ul className="grid-end-12 md:grid-end-8 md:grid-start-3 relative flex flex-wrap items-center justify-center md:justify-between">
              {categories?.[0] &&
                categories.map(category => (
                  <li key={category} className="relative block">
                    <button
                      type="button"
                      className="block mx-3 md:mx-0 mb-2 md:mb-0 pt-1 sm:pt-2 md:pt-1 pb-1"
                      onClick={() => {
                        if (
                          typeof window !== `undefined` &&
                          scrollRefs?.preorder?.current
                        ) {
                          window.scrollTo({
                            top:
                              device === `desktop`
                                ? scrollRefs.preorder.current.offsetTop - 175
                                : scrollRefs.preorder.current.offsetTop - 120,
                            behavior: `smooth`
                          });
                        }

                        // setActiveCategory(category);
                        toggleCategory(category);
                      }}
                    >
                      <div className="w-full relative flex items-center">
                        <div
                          className="products-page__filter relative overflow-hidden flex items-center justify-center rounded-full mr-2 p-1"
                          style={{ width: `20px`, height: `20px` }}
                        >
                          {activeCategories?.[0] &&
                            activeCategories.includes(category) && (
                              <div className="animation-pop w-full h-full relative overflow-hidden rounded-full bg-orange"></div>
                            )}
                        </div>

                        <span className="f5 text-orange">{category}</span>
                      </div>
                    </button>
                  </li>
                ))}
            </ul>

            {squiggleJSX}
          </div>
        </section>

        <div
          id="preorder"
          ref={scrollRefs.preorder}
          className="animation-appear-down-slow animation-delay-5 pb-12"
        >
          <ProductGrid
            categorised
            heading="All Products"
            open={open}
            products={products}
          />
        </div>

        <div ref={scrollRefs.subscription}>
          <Subscription subscriptions={subscriptions} />
        </div>
      </Layout>

      <Footer />
    </>
  );
};

export default ProductsPage;

export const query = graphql`
  query ProductsPage($id: String!) {
    allDataYaml {
      edges {
        node {
          open
        }
      }
    }

    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
      }
    }

    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "product-page" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }

          frontmatter {
            title
            shopifyHandle
            priority
            categories
            description
            new
            save

            image {
              childImageSharp {
                fluid(maxWidth: 1280, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
              publicURL
            }
          }
        }
      }
    }

    allShopifyProduct {
      edges {
        node {
          id
          title
          description
          handle
          images {
            originalSrc
          }
          productType
          tags
          vendor
          variants {
            id
            sku
            title
            image {
              originalSrc
            }
            price
            compareAtPrice
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }

    allShopifyAdminProduct {
      edges {
        node {
          products {
            handle
            variants {
              alternative_id
              title
            }
          }
        }
      }
    }
  }
`;
